<style scoped>
tr:nth-child(odd) {
  background: #f6f6f6;
}
</style>
<template>
  <v-container>
    <v-layout row wrap my-5 pb-3>
      <!--
        <v-flex xs12>
          <v-alert type="info" outline dismissible :value="true"
            >Logged in as: {{ getName }}
          </v-alert>
        </v-flex>
      -->
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">home</v-icon>
          Evident Extranet
        </h3>
        Using the Evident Extranet, you can order products via Internet and
        check your individual order status online.
        <blockquote>
          Please use the quick access tabs below for placing an order or get
          access to your order status.
        </blockquote>
      </v-flex>
      <v-flex xs12 mt-5>
        <search-form
          @submitSearchQuery="onSubmitSearchQuery"
          @clearSearch="onClearSearch"
        ></search-form>
      </v-flex>
    </v-layout>
    <v-layout align-start justify-space-between row>
      <v-flex xs5>
        <v-card :hover="true" class="grey--text">
          <v-flex>
            <v-card-title primary-title>
              <h4>
                <v-icon large color="yellow">shopping_basket</v-icon>
                Table To Basket
              </h4>
            </v-card-title>
            <v-img
              :src="require('@/assets/img/table2basket.png')"
              contain
              max-height="150"
            ></v-img>
            <v-card-actions class="pa-3">
              <v-btn
                block
                ripple
                class="white--text primary"
                to="/table_to_basket"
              >
                Order now with Table To Basket
              </v-btn>
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-flex>
      <v-flex xs5>
        <v-card :hover="true" class="grey--text">
          <v-flex>
            <v-card-title primary-title>
              <h4>
                <v-icon large color="yellow">playlist_add_check</v-icon>
                Order Status
              </h4>
            </v-card-title>
            <v-img
              :src="require('@/assets/img/order-status-check.png')"
              contain
              max-height="150"
            ></v-img>
            <v-card-actions class="pa-3">
              <v-btn
                block
                ripple
                class="white--text primary xs12"
                to="/order_status"
              >
                Check your Order Status
              </v-btn>
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import SearchForm from "@/components/SearchForm.vue";

export default {
  components: {
    SearchForm
  },
  methods: {
    ...mapActions("search", ["fetchSapMaterials"]),
    ...mapMutations({
      onClearSearch: "search/clear"
    }),
    onSubmitSearchQuery(value) {
      this.fetchSapMaterials(value);
      this.$router.push({ name: "search" });
    }
  }
};
</script>
